import {
  Grid,
  Typography,
  IconButton,
  Tooltip,
  CircularProgress,
} from "@mui/material";
import PConfirm from "../../../components/pos/PConfirm";
import PDatePicker from "../../../components/pos/PDatePicker";
import PDialog from "../../../components/pos/PDialog";
import PSelect from "../../../components/pos/PSelect";
import PText from "../../../components/pos/PText";
import { PricingUtils } from "../../../utils/PricingUtils";
import db from "../../../db/db";
import MUIDataTable from "mui-datatables";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../../utils/API";
import { StringUtils } from "../../../utils/StringUtils";
import { SyncUtils } from "../../../utils/SyncUtils";
import GenericReportViewer from "./../../reports/GenericReportViewer";
import DescriptionIcon from "@mui/icons-material/Description";
import Button from "@mui/material/Button";
import QuickPurchaseRequestWindow from "../../purchase/purchase-request/quick-purchase-request/QuickPurchaseRequestWindow";
import { PropaneSharp } from "@mui/icons-material";
import { set } from "lodash";
import { PrintUtils } from "../../../utils/PrintUtils";
import Link from "@mui/material/Link";
import PFileViewer from "../../../components/pos/PFileViewer";

export default function CustomerAccountingCrud2(props) {
  const { t } = useTranslation();
  const translate = t;
  const [origObject, setOrigObject] = useState(null);
  const [mode, setMode] = useState("create");
  const [openWindow, setOpenWindow] = useState(false);
  const [windowTitle, setWindowTitile] = useState("");
  const [confirmContext, setConfirmContext] = useState({ open: false });
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [discountError, setDiscountError] = useState("");

  const [liveValidation, setLiveValidation] = useState(false);

  const [voucherNumber, setVouchernumber] = useState("AUTO");
  const [voucherNumberError, setVouchernumberError] = useState("");
  const [customer, setCustomer] = useState("");
  const [customerAccount, setCustomerAccount] = useState({});
  const [customerError, setCustomerError] = useState("");
  const [account, setAccount] = useState("");
  const [accountError, setAccountError] = useState("");
  const [checkNo, setCheckNo] = useState("");
  const [chequeNoError, setChequeNoError] = useState("");
  const [status, setStatus] = useState("");
  const [amount, setAmount] = useState("");
  const [amountError, setAmountError] = useState("");
  const [total, setTotal] = useState("");
  const [toPay, setToPay] = useState("");
  const [discount, setDiscount] = useState("");
  const [paymentType, setPaymentType] = useState(null);
  const [paymentTypeError, setPaymentTypeError] = useState("");
  const [fullPayment, setFullPayment] = useState(true);
  const [payed, setPayed] = useState("");
  const [payedError, setPayedError] = useState("");
  const [remarks, setRemarks] = useState("");
  const [remarksError, setRemarksError] = useState("");
  const [balance, setBalance] = useState(0);
  const [balanceError, setBalanceError] = useState("");
  const [transactionDate, setTransactiondate] = useState("");
  const [transactionDateError, setTransactiondateError] = useState("");
  const [transactionMode, setTransactionMode] = useState("");
  const [type, setType] = useState("");
  const [optionsLedger, setOptionsLedger] = useState([]);
  const [optionsCustomer, setOptionsCustomer] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [option, setOption] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [getPrint, setGetPrint] = useState(false);
  const [chequeDate, setChequeDate] = useState("");
  const [chequeDateError, setChequeDateError] = useState("");
  const [openFileViewWindow, setOpenFileViewWindow] = useState(false);
  const [previewFileList, setPreviewFileList] = useState([]);
  const [totalPaidAmount, setTotalPaidAmount] = useState("");
  const [groupedReturnAmount, setGroupedReturnAmount] = useState("");
  const [groupedSaleAmount, setGroupedSaleAmount] = useState("");
  const [showProgressDialog, setShowProgressDialog] = useState(false);
  const [progressMessage, setProgressMessage] = useState("");
  const [newButtonClicked, setnewButtonClicked] = useState(false);
  const [showPayCol, setShowPayCol] = useState(true);
  function validate() {
    if (props.paymentType.id == 4) {
      let flag = true;
      let arr = [...tableData];
      let selectedFlag = false;
      let vBalanceFlag = false;
      for (let gridrow of arr) {
        if (!gridrow.PayedAmount || gridrow.PayedAmount === "") {
          gridrow["paidAmountError"] = "Paid amount required";
          flag = false;
        } else {
          gridrow["paidAmountError"] = "";
        }
        if (gridrow.vBalanceAmount < 0) {
          vBalanceFlag = true;
        }
        if (gridrow.selected) {
          selectedFlag = true;
        }
      }
      if (!flag) {
        setTableData(arr);
      }
      if (!selectedFlag) {
        props.showMessage("error", translate("Select atleast one row"));
        flag = false;
      }
      if (vBalanceFlag) {
        props.showMessage(
          "error",
          translate("Paid amount should not be more than balance amount")
        );
        flag = false;
      }
      if (!customer || customer === "") {
        setCustomerError(translate("Customer is required"));
        flag = false;
      }
      if (!account || account === "") {
        setAccountError(translate("Account is required"));
        flag = false;
      }
      if (!payed || payed === "") {
        setAmountError(translate("Amount Payed is required"));
        flag = false;
      }
      if (!payed || payed === "") {
        setPayedError(translate("Paid is required"));
        flag = false;
      }
      if (!transactionDate || transactionDate === "") {
        setTransactiondateError(translate("Transaction date is required"));
        flag = false;
      }
      if (
        (!chequeDate || chequeDate === "") &&
        props.transactionMode === "Bank"
      ) {
        setChequeDateError(translate("Cheque date is required"));
        flag = false;
      }
      if ((!checkNo || checkNo === "") && props.transactionMode === "Bank") {
        setChequeNoError(translate("Cheque No is required"));
        flag = false;
      }
      /*if (payed < 0) {
        setDiscountError(translate("Invalid Discount"));
        flag = false;
      }*/
      if (!flag) {
        setLiveValidation(true);
      }
      return flag;
    } else {
      let flag = true;
      let selectedFlag = false;
      if (props.paymentType.id == 1) {
        let arr = [...tableData];
        for (let gridrow of arr) {
          if (gridrow.selected) {
            selectedFlag = true;
          }
        }
        if (!selectedFlag) {
          props.showMessage("error", translate("Select atleast one row"));
          flag = false;
        }
      }

      // if (payed < 0) {
      //   setDiscountError(translate("Invalid Discount"));
      //   flag = false;
      // }

      if (!customer || customer === "") {
        setCustomerError(translate("Customer is required"));
        flag = false;
      }
      if (!account || account === "") {
        setAccountError(translate("Account is required"));
        flag = false;
      }
      if (!payed || payed === "") {
        setAmountError(translate("Amount payed is required"));
        flag = false;
      }
      if ((!payed || payed === "" || payed == 0) && props.paymentType.id == 3) {
        setPayedError(translate("Paid is required"));
        flag = false;
      }

      if (props.paymentType.id === 2) {
        if (customer) {
          if (
            groupedReturnAmount == 0 &&
            groupedSaleAmount == 0 &&
            balance == 0
          ) {
            props.showMessage("error", translate("Nothing to settle"));
            flag = false;
          }

          if (groupedReturnAmount > 0 && groupedSaleAmount == 0) {
            props.showMessage(
              "error",
              translate(
                "In the partial payment type we can't settle advance and return invoice without sale invoice"
              )
            );
            flag = false;
          }

          if (groupedReturnAmount == 0 && groupedSaleAmount > 0) {
            if (
              groupedSaleAmount > 0 &&
              (payed == 0 || !payed || payed === "")
            ) {
              flag = false;
              setPayedError(translate("Paid is required"));
            }
            if (groupedSaleAmount > 0 && balance < 0) {
              flag = false;
              setPayedError(translate("Invalid paid"));
            }
          }

          if (groupedReturnAmount > 0 && groupedSaleAmount > 0) {
            if (groupedReturnAmount == groupedSaleAmount) {
              flag = true;
            }

            if (groupedSaleAmount > groupedReturnAmount) {
              if (!payed || payed === "") {
                flag = false;

                setPayedError(translate("Paid is required"));
              }
              if (balance < 0) {
                flag = false;

                setPayedError(translate("Invalid paid"));
              }
            }

            if (groupedReturnAmount > groupedSaleAmount) {
              flag = true;
            }
          }
        }
      }

      if (!transactionDate || transactionDate === "") {
        setTransactiondateError(translate("Transaction date is Required"));
        flag = false;
      }
      if (
        (!chequeDate || chequeDate === "") &&
        props.transactionMode === "Bank"
      ) {
        setChequeDateError(translate("Cheque date is required"));
        flag = false;
      }
      if ((!checkNo || checkNo === "") && props.transactionMode === "Bank") {
        setChequeNoError(translate("Cheque No is required"));
        flag = false;
      }
      /*CODEGEN_VALIDATE ######## DO_NOT_REMOVE ###########*/
      if (!flag) {
        setLiveValidation(true);
      }
      return flag;
    }
  }

  useEffect(() => {
    if (props.selectedRowFromGrid) {
      setMode(props.mode);
      setType("CUSTOMER");
      populateDataFromSelectedRow(props.selectedRowFromGrid);
    }
  }, [props.selectedRowFromGrid]);

  useEffect(() => {
    if (liveValidation && chequeDate === "") {
      setChequeDateError(translate("Cheque date is required"));
    } else {
      setChequeDateError("");
    }
  }, [chequeDate]);

  useEffect(() => {
    if (liveValidation && checkNo === "") {
      setChequeNoError(translate("Cheque No is required"));
    } else {
      setChequeNoError("");
    }
  }, [checkNo]);

  useEffect(() => {
    if (liveValidation && customer === "")
      setCustomerError(translate("customer is required"));
    else setCustomerError("");
  }, [customer]);

  useEffect(() => {
    if (liveValidation && account === "")
      setAccountError(translate("Account is required"));
    else setAccountError("");
  }, [account]);

  useEffect(() => {
    if (liveValidation && amount === "")
      setAmountError(translate("Amount is required"));
    else setAmountError("");
  }, [amount]);

  useEffect(() => {
    if (liveValidation && payed === "")
      setPayedError(translate("Paid is required"));
    else setPayedError("");
  }, [payed]);

  useEffect(() => {
    if (liveValidation && transactionDate === "")
      setTransactiondateError(translate("Transaction date is required"));
    else setTransactiondateError("");
  }, [transactionDate]);

  // useEffect(() => {
  //   if (liveValidation && payed < 0)
  //     setDiscountError(translate("Invalid Discount"));
  //   else setDiscountError("");
  // }, [discount]);

  useEffect(() => {
    showAccountingCrud();
  }, []);

  useEffect(() => {
    if (optionsLedger?.length == 1) {
      setAccount(optionsLedger[0]);
    }
  }, [optionsLedger]);

  async function getAllLedgers(type) {
    try {
      let ledgers = await API.get("/api/v1/ledgerlist/" + type);
      setOptionsLedger(populateLedgreOptions(ledgers.data));
    } catch (err) {
      console.error(err);
      if (type === "Bank") {
        props.showMessage("error", "Not able to retrive any bank accounts");
      } else if (type === "Cash") {
        props.showMessage("error", "Not able to retrive any bank accounts");
      } else props.showMessage("error", "Not able to retrive any accounts");
    }
  }

  function showAccountingCrud() {
    if (props.transactionMode === "Cash") {
      setWindowTitile("Customer CASH VOUCHER");
      setType("CUSTOMER");
    } else {
      setWindowTitile("Customer BANK VOUCHER");
      setType("CUSTOMER");
    }
    populateCustomerOptions();
    getAllLedgers(props.transactionMode);
    let d = new Date();
    d.setHours(d.getHours());
    d.setMinutes(d.getMinutes());
    d.setSeconds(d.getSeconds());
    setTransactiondate(d.toISOString());
  }

  async function populateDataFromSelectedRow(id) {
    try {
      let resultData = [];
      let { data } = await API.get("/api/v1/accounting/transaction/" + id);

      for (let d of data.accountingTransactionItemList) {
        if (data.paymentType == 1) {
          resultData.push({
            transactionNo: d.invoiceNumber,
            transactionDate: d.date,
            paymentMode: d.paymentMode,
            vOrderType: d.vorderType,
            amount: d.vbalanceAmount,
            actualAmountToPay: d.actualAmountToPay,
            amountPaid: d.payedAmount,
            balance: 0.0,
            id: d.rowId,
            transactionType: (d.vorderType = "sale" ? "SALE" : "SALE_RETURN"),
            invoiceType: (d.vorderType = "sale" ? "SALE" : "SALE_RETURN"),
          });
        }
        if (data.paymentType == 2) {
          resultData.push({
            transactionNo: d.invoiceNumber,
            transactionDate: d.date,
            paymentMode: d.paymentMode,
            vOrderType: d.vorderType,
            amount: d.actualAmountToPay,
            amountPaid: d.payedAmount,
            actualAmountToPay: d.actualAmountToPay,
            balance: d.vbalanceAmount,
            id: d.rowId,
            transactionType: d.vorderType,
            invoiceType: (d.vorderType = "sale" ? "SALE" : "SALE_RETURN"),
          });
        }
        if (data.paymentType == 3) {
          resultData.push({
            transactionNo: d.invoiceNumber,
            transactionDate: d.date,
            paymentMode: d.paymentMode,
            amountPaid: d.payedAmount,
            vOrderType: d.vorderType,
            amount: d.actualAmountToPay,
            balance: d.vbalanceAmount,
          });
        }
        if (data.paymentType == 4) {
          resultData.push({
            transactionNo: d.invoiceNumber,
            transactionDate: d.date,
            paymentMode: d.paymentMode,
            vOrderType: d.vorderType,
            actualAmountToPay: d.actualAmountToPay,
            amount: d.actualAmountToPay,
            amountPaid: d.payedAmount,
            vBalanceAmount: d.vbalanceAmount,
            PayedAmount: d.payedAmount,
            discount: d.gridDiscount,
            id: d.rowId,
            transactionType: (d.vorderType = "sale" ? "SALE" : "SALE_RETURN"),
            invoiceType: (d.vorderType = "sale" ? "SALE" : "SALE_RETURN"),
          });
        }
      }

      setTableData(resultData);
      setOrigObject(data);
      setShowPayCol(false);
      populateData(data);
    } catch (err) {
      console.log(err);
      props.showMessage(
        "error",
        translate(
          "Not able to retrive vendor accounting transactions data from server"
        )
      );
    }
  }

  function populateData(bean) {
    setWindowTitile(bean.voucherNumber);
    setVouchernumber(bean.voucherNumber);
    setTransactiondate(bean.transactionDate2);
    setRemarks(bean.description);
    setCheckNo(bean.chequeNo);
    setChequeDate(bean.chequeDate);
    setAccount(
      bean.toLedger
        ? {
            id: bean.toLedger.id,
            name: bean.toLedger.name,
            value: bean.toLedger,
          }
        : null
    );
    setCustomer(
      bean.fromLedger
        ? {
            id: bean.fromLedger.id,
            name: bean.fromLedger.name,
            value: bean.fromLedger,
          }
        : null
    );
  }

  function populateCustomerOptions() {
    setOptionsCustomer([]);
    db.customer.toArray(function (data) {
      let dat = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].creditCustomer) {
          dat.push({ id: data[i], name: data[i].name, cid: data[i].id });
        }
      }
      setOptionsCustomer(dat);
    });
  }

  function populateLedgreOptions(data) {
    const dataArray = [];
    data.map((item, key) => dataArray.push({ id: item, name: item.name }));
    return dataArray;
  }

  async function getCustomerAccount(customer) {
    let user = "CUSTOMER";
    setCustomerAccount([]);
    setSelectedRows([]);
    let arr = [];
    let { data } = await API.get("/api/v1/ledger/" + customer.ledgerId);
    setCustomerAccount({ id: data, name: data.name });

    setIsLoading(true);
    const result = await API.get(
      "/api/v1/paymenttransaction/pendinglist/" + customer.id
    );

    if (result.data.length > 0) {
      arr.push(...generateSaleAndReturnData(result.data));
    }

    const openingBalanceResult = await API.get(
      "/api/v1/paymenttransaction/getopeningbalance/pendinglist/" +
        user +
        "/" +
        customer.id
    );

    if (openingBalanceResult.data.length > 0) {
      arr.push(...generateOpeningBalanceData(openingBalanceResult.data));
    }

    const advance = await API.get(
      "/api/v1/accountingtransaction/advancebycustomer/" + customer.ledgerId
    );

    if (advance.data.length > 0) {
      arr.push(...generateAdvanceData(advance.data));
    }

    const opt = { ...option };
    setOption(opt);

    if (result != null && arr.length > 0) {
      for (let d of arr) {
        d["vBalanceAmount"] = d.balance;
        if (d.transactionType === "OpeningBalance") {
          d["vOrderType"] = d.transactionType;
        } else {
          if (!d.isAdvance) {
            // hacky code
            d["vOrderType"] =
              d.transactionType === "SALE_RETURN" ? "Return" : "sale";
          }
        }
      }
      setTableData(arr);
      findTotalAmount(arr);
    } else {
      setTableData([]);
    }
    setIsLoading(false);
  }

  useEffect(() => {
    let tot = 0;
    let paidAmount = 0;
    let totalGridDiscount = 0;
    let girdTotalAmountPaid = 0;
    let groupedReturnAmount = 0;
    let groupedSaleAmount = 0;

    for (let d of tableData) {
      if (d.selected) {
        if (props.paymentType.id === 1) {
          girdTotalAmountPaid =
            girdTotalAmountPaid +
            parseFloat(d.balance) *
              (d.transactionType === "SALE_RETURN" || d.orderType === "Advance"
                ? -1
                : 1);
        }
        if (props.paymentType.id === 4) {
          girdTotalAmountPaid =
            girdTotalAmountPaid +
            parseFloat(d.PayedAmount) *
              (d.transactionType === "SALE_RETURN" || d.orderType === "Advance"
                ? -1
                : 1);
        }
      }
      if (props.paymentType && props.paymentType.id === 2) {
        tot =
          tot +
          parseFloat(d.balance) *
            (d.transactionType === "SALE_RETURN" || d.orderType === "Advance"
              ? -1
              : 1);
        groupedReturnAmount =
          groupedReturnAmount +
          parseFloat(
            d.transactionType === "SALE_RETURN" || d.orderType === "Advance"
              ? d.balance
              : 0
          );

        groupedSaleAmount =
          groupedSaleAmount +
          parseFloat(
            !(d.transactionType === "SALE_RETURN" || d.orderType === "Advance")
              ? d.balance
              : 0
          );
      }
      if (d.selected)
        tot =
          tot +
          parseFloat(d.balance) *
            (d.transactionType === "SALE_RETURN" || d.orderType === "Advance"
              ? -1
              : 1);
      if (d.selected)
        paidAmount =
          paidAmount +
          parseFloat(d.PayedAmount ? d.PayedAmount : 0) *
            (d.transactionType === "SALE_RETURN" || d.orderType === "Advance"
              ? -1
              : 1);
      if (d.selected)
        totalGridDiscount =
          totalGridDiscount + parseFloat(d.gridDiscount ? d.gridDiscount : 0);
    }
    setTotalPaidAmount(girdTotalAmountPaid);
    setTotal(
      StringUtils.formattedNumber(tot, props.context.store.currencyDecimal)
    );

    if (props.paymentType && props.paymentType.id == 1) {
      setStatus("CLEARED");
      setToPay(
        StringUtils.formattedNumber(
          tot - (discount ? parseFloat(discount) : 0),
          props.context.store.currencyDecimal
        )
      );

      setPayed(
        StringUtils.formattedNumber(
          tot - (discount ? parseFloat(discount) : 0),
          props.context.store.currencyDecimal
        )
      );

      setBalance(
        StringUtils.formattedNumber(0, props.context.store.currencyDecimal)
      );
    }
    if (props.paymentType && props.paymentType.id == 2) {
      setToPay(
        StringUtils.formattedNumber(
          tot - (discount ? parseFloat(discount) : 0),
          props.context.store.currencyDecimal
        )
      );

      setBalance(
        StringUtils.formattedNumber(
          tot - (payed ? payed : 0) - (discount ? parseFloat(discount) : 0),
          props.context.store.currencyDecimal
        )
      );

      setPayed(
        groupedReturnAmount == groupedSaleAmount ||
          groupedReturnAmount > groupedSaleAmount
          ? 0
          : ""
      );

      setGroupedReturnAmount(groupedReturnAmount);
      setGroupedSaleAmount(groupedSaleAmount);
    }
    if (props.paymentType && props.paymentType.id == 3) {
      setStatus("PENDING");
      setToPay(
        StringUtils.formattedNumber(0, props.context.store.currencyDecimal)
      );
      setBalance(
        StringUtils.formattedNumber(0, props.context.store.currencyDecimal)
      );
    } else if (props.paymentType && props.paymentType.id == 4) {
      setStatus("CLEARED");
      setPayed(
        StringUtils.formattedNumber(
          paidAmount,
          props.context.store.currencyDecimal
        )
      );

      setBalance(
        StringUtils.formattedNumber(
          (tot < 0 ? tot * -1 : tot * 1) - paidAmount - totalGridDiscount,
          // tot - paidAmount - (discount ? parseFloat(discount) : 0),
          props.context.store.currencyDecimal
        )
      );

      setDiscount(
        StringUtils.formattedNumber(
          // totalGridDiscount
          totalGridDiscount ? parseFloat(totalGridDiscount) : 0,
          props.context.store.currencyDecimal
        )
      );

      setToPay(
        StringUtils.formattedNumber(
          (tot < 0 ? tot * -1 : tot * 1) - totalGridDiscount,
          // (tot < 0 ? tot * -1 : tot * 1) - totalGridDiscount + paidAmount,
          // tot - (discount ? parseFloat(discount) : 0),
          props.context.store.currencyDecimal
        )
      );
    }
  }, [tableData]);

  function generateSaleAndReturnData(data) {
    let saleAndReturnArray = [];
    data.forEach((element) => {
      let saleAndReturn = new Object();
      saleAndReturn["id"] = element.id;
      saleAndReturn["transactionNo"] = element.transactionNo;
      saleAndReturn["transactionDate"] = element.transactionDate;
      saleAndReturn["paymentMode"] = element.paymentMode;
      saleAndReturn["amountPaid"] = element.amountPaid;
      saleAndReturn["amount"] =
        element.amount < 0 ? element.amount * -1 : element.amount * 1;
      saleAndReturn["vBalanceAmount"] =
        element.balance < 0 ? element.balance * -1 : element.balance * 1;
      saleAndReturn["balance"] =
        element.balance < 0 ? element.balance * -1 : element.balance * 1;
      saleAndReturn["transactionType"] =
        element.balance < 0 || element.transactionType == "SALE_RETURN"
          ? "SALE_RETURN"
          : "SALE";
      saleAndReturn["invoiceType"] = element.transactionType;

      saleAndReturnArray.push(saleAndReturn);
    });

    return saleAndReturnArray;
  }

  function generateOpeningBalanceData(data) {
    let openingBlance = [];
    data.forEach((element) => {
      let opening = new Object();
      opening["id"] = element.id;
      opening["transactionNo"] = "N/A";
      opening["transactionDate"] = element.transactionDate;
      opening["amountPaid"] = 0;
      opening["paymentMode"] = element.paymentMode;
      opening["amount"] = element.amount;
      opening["balance"] = element.balance ? element.balance : element.amount;
      opening["amountPaid"] = opening.amount - opening["balance"];
      opening["vBalanceAmount"] =
        element.balance < 0 ? element.balance * -1 : element.balance * 1;
      opening["transactionType"] = element.transactionType;
      opening["isAdvance"] = element.paymentMode === "CREDIT" ? true : false;
      opening["orderType"] =
        element.paymentMode === "CREDIT" ? "Advance" : element.paymentMode;
      opening["vOrderType"] = element.transactionType;
      openingBlance.push(opening);
    });
    return openingBlance;
  }

  function generateAdvanceData(data) {
    let advances = [];
    data.forEach((element) => {
      let advance = new Object();
      advance["id"] = element.id;
      advance["code"] = "Advance";
      advance["transactionNo"] = element.voucherNumber;
      advance["transactionDate"] = element.transactionDate2;
      advance["amount"] = element.amount;
      advance["paymentMode"] = element.transactionMode;
      advance["balance"] = element.balanceAmount
        ? element.balanceAmount
        : element.amount;
      advance["isAdvance"] = true;
      advance["vBalanceAmount"] = 0;
      advance["orderType"] = "Advance";
      advance["vOrderType"] = "Advance";
      advances.push(advance);
    });

    return advances;
  }

  function findTotalAmount(data) {
    setAmount(0);
    let totalAmount = 0;
    data.map((item, key) => {
      if (item.transactionType === "SALE_RETURN")
        totalAmount = totalAmount - parseFloat(item.balance);
      else totalAmount = totalAmount + parseFloat(item.balance);
    });
    setAmount(
      PricingUtils.formattedNumber(
        totalAmount,
        props.context.store.currencyDecimal
      )
    );
  }

  function onCloseWindow() {
    if (mode == "create" && !newButtonClicked) {
      props.closeParentWindow();
      props.setShowCrud(false);
    }
    if (
      mode == "create" &&
      newButtonClicked &&
      !props.selectedRowFromGrid &&
      props.showCrud
    ) {
      props.setShowCrud(false);
      props.closeParentWindow();
    }

    if (
      mode == "create" &&
      newButtonClicked &&
      props.selectedRowFromGrid &&
      !props.showCrud
    ) {
      props.setShowCrud(false);
    }

    if (
      mode == "create" &&
      newButtonClicked &&
      props.selectedRowFromGrid == null &&
      !props.showCrud
    ) {
      props.setShowCrud(false);
      props.closeParentWindow();
    }

    if (
      mode == "view" &&
      newButtonClicked &&
      props.selectedRowFromGrid == null
    ) {
      props.closeParentWindow();
      props.setShowCrud(false);
    }
    if (mode == "view" && !newButtonClicked && props.selectedRowFromGrid) {
      props.setShowCrud(false);
      props.onRefresh();
    }
    if (
      mode == "view" &&
      !newButtonClicked &&
      props.selectedRowFromGrid == null
    ) {
      props.closeParentWindow();
      props.setShowCrud(false);
    }
    if (mode == "view" && newButtonClicked && props.selectedRowFromGrid) {
      props.onRefresh();
      props.setShowCrud(false);
    }
  }

  function onPrintReportIconButtonClicked() {
    if (customer === "") {
      props.showMessage("error", translate("Please select customer"));
    } else {
      let paramsList = [
        {
          key: "transactionId",
          value: customer.id,
          name: customer.name,
        },
      ];
      biRef.genericReportView.showGenericReportViewer(
        "reports/generic/customer_receipt_voucher_pending",
        paramsList,
        "Customer transaction",
        "v2"
      );
    }
  }

  async function invoiceHyperLinkClicked(rowdata) {
    try {
      let sort = '[{id:"date",sortOrder:"DESC"}]';
      let filter = { and: [] };

      filter.and.push({
        op: "eq",
        key: "invoiceNo",
        value: rowdata.transactionNo,
      });

      const result = await API.get(
        "/e_search/sales?range=" +
          encodeURIComponent("[" + 1 * (1 - 1) + "," + 1 + "]") +
          "&filter=" +
          encodeURIComponent(JSON.stringify(filter)) +
          "&sort=" +
          encodeURIComponent(sort) +
          "&searchType=" +
          encodeURIComponent(rowdata.invoiceType)
      );

      let data;
      if (rowdata.invoiceType === "SALE_RETURN") {
        data = await API.get("/api/v1/sale/return/" + result.data.data[0]._id);
      } else {
        data = await API.get("/api/v1/sale/" + result.data.data[0]._id);
      }

      props.showProgress(translate("Generating "));
      PrintUtils.augmentSaleDetailsForPrint(
        data.data,
        props.context.store.currencyDecimal,
        rowdata.invoiceType
      );
      let pdf = await PrintUtils.generateReceiptAsPdf(
        rowdata.invoiceType === "SALE_RETURN"
          ? "SALE_RETURN_RECEIPT_PRINT_FORMAT"
          : "SALE_RECEIPT_PRINT_FORMAT",
        data.data,
        0
      );
      let fileList = [];
      let item = {
        selected: true,
        previewObj: pdf.data,
        fileType: "DOCUMENT",
      };
      fileList.push(item);
      setPreviewFileList(fileList);
      setOpenFileViewWindow(true);
      props.hideProgress();
    } catch (err) {
      console.error(err);
    }
  }

  const columns = [
    {
      name: "transactionNo",
      label: translate("Invoice Number"),
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div>
              {tableData[tableMeta.rowIndex].vOrderType == "Advance" ||
              tableData[tableMeta.rowIndex].vOrderType == "OpeningBalance" ? (
                <div style={{ paddingLeft: 20 }}>{value}</div>
              ) : (
                <div style={{ paddingLeft: 20 }}>
                  {" "}
                  <Link
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      invoiceHyperLinkClicked(tableData[tableMeta.rowIndex]);
                    }}
                    underline="always"
                  >
                    {value}
                  </Link>
                </div>
              )}
            </div>
          );
        },
      },
    },

    {
      name: "transactionDate",
      label: translate("Date"),
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return StringUtils.formatDate(new Date(value), 1);
        },
      },
    },
    {
      name: "paymentMode",
      label: translate("Mode"),
    },
    {
      // name: "transactionType",
      name: "vOrderType",
      label: translate("Type"),
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          // return value == "SALE_RETURN" ? <div>Return</div> : <div>Sale</div>;
          return <div>{value}</div>;
        },
      },
    },
    {
      name: "amount",
      label: translate("Total"),
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return StringUtils.formattedNumber(
            value,
            props.context.store.currencyDecimal
          );
        },
      },
    },
    {
      name: "amountPaid",
      options: {
        customHeadLabelRender: (value, tableMeta, updateValue) => (
          <div style={{ paddingLeft: 20 }}>{translate("Received")}</div>
        ),
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ paddingLeft: 20 }}>
              {StringUtils.formattedNumber(
                value,
                props.context.store.currencyDecimal
              )}
            </div>
          );
        },
      },
    },
    {
      name: "balance",
      label: translate("Balance"),
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return StringUtils.formattedNumber(
            value,
            props.context.store.currencyDecimal
          );
        },
      },
    },
  ];

  const options = {
    filterType: "checkBox",
    serverSide: true,
    tableBodyMaxHeight: "100%",
    tableBodyHeight: 285,
    download: false,
    print: false,
    filter: false,
    viewColumns: false,
    pagination: false,
    viewColumns: false,
    rowsSelected: selectedRows,
    onRowSelectionChange: (
      currentRowsSelected,
      allRowsSelected,
      rowsSelected
    ) => {
      handleRowSelectionChange(allRowsSelected, rowsSelected);
    },
    customToolbar: () => {
      return (
        <React.Fragment>
          <Tooltip title={"Pending receipt"}>
            <IconButton
              color="primary"
              onClick={onPrintReportIconButtonClicked}
            >
              <DescriptionIcon />
            </IconButton>
          </Tooltip>
        </React.Fragment>
      );
    },
  };

  const editableColumns = [
    {
      name: "transactionNo",
      label: translate("Invoice Number"),
      options: {
        filter: false,
        sort: false,
        customHeadLabelRender: (value, tableMeta, updateValue) => (
          <div style={{ paddingLeft: 20 }}>{translate("Invoice number")}</div>
        ),
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ paddingLeft: 20 }}>
              {tableData[tableMeta.rowIndex].vOrderType == "Advance" ||
              tableData[tableMeta.rowIndex].vOrderType == "OpeningBalance" ? (
                <div>{value}</div>
              ) : (
                <div>
                  {" "}
                  <Link
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      invoiceHyperLinkClicked(tableData[tableMeta.rowIndex])
                    }
                    underline="always"
                  >
                    {value}
                  </Link>
                </div>
              )}
            </div>
          );
        },
      },
    },

    {
      name: "transactionDate",
      label: translate("Date"),
      options: {
        filter: false,
        sort: false,
        customHeadLabelRender: (value, tableMeta, updateValue) => (
          <div style={{ paddingLeft: 20 }}>{translate("Date")}</div>
        ),
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ paddingLeft: 20 }}>
              {StringUtils.formatDate(new Date(value), 1)}
            </div>
          );
        },
      },
    },
    {
      name: "paymentMode",
      label: translate("Mode"),
      options: {
        filter: false,
        sort: false,
        customHeadLabelRender: (value, tableMeta, updateValue) => (
          <div style={{ paddingLeft: 20 }}>{translate("Mode")}</div>
        ),
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ paddingLeft: 20 }}>{value}</div>
        ),
      },
    },
    {
      // name: "transactionType",
      name: "vOrderType",
      label: translate("Type"),
      options: {
        filter: false,
        sort: false,
        customHeadLabelRender: (value, tableMeta, updateValue) => (
          <div style={{ paddingLeft: 20 }}>{translate("Type")}</div>
        ),

        customBodyRender: (value, tableMeta, updateValue) => {
          // return value == "SALE_RETURN" ? <div>Return</div> : <div>Sale</div>;
          // return getTransactionType(value);
          return <div style={{ paddingLeft: 20 }}>{value}</div>;
        },
      },
    },
    {
      name: "amount",
      label: translate("Total"),
      options: {
        customHeadLabelRender: (value, tableMeta, updateValue) => (
          <div style={{ paddingLeft: 20 }}>{translate("Total")}</div>
        ),
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ paddingLeft: 20 }}>
              {StringUtils.formattedNumber(
                value,
                props.context.store.currencyDecimal
              )}
            </div>
          );
        },
      },
    },
    {
      name: "amountPaid",
      options: {
        customHeadLabelRender: (value, tableMeta, updateValue) => (
          <div style={{ paddingLeft: 20 }}>{translate("Received")}</div>
        ),
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ paddingLeft: 20 }}>
              {StringUtils.formattedNumber(
                value,
                props.context.store.currencyDecimal
              )}
            </div>
          );
        },
      },
    },
    {
      name: "selected",
      label: translate("Receive"),
      options: {
        filter: false,
        sort: false,
        display: showPayCol,
        customHeadLabelRender: (value, tableMeta, updateValue) => (
          <div style={{ paddingLeft: 20 }}>{translate("Receive")}</div>
        ),
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div>
              {value ? (
                <div style={{ width: "50%", paddingLeft: 20 }}>
                  <PText
                    type="number"
                    error={tableData[tableMeta.rowIndex].paidAmountError}
                    onChange={(e) => {
                      let tempData = [...tableData];
                      tempData[tableMeta.rowIndex].PayedAmount = e.target.value;
                      tempData[tableMeta.rowIndex].vBalanceAmount =
                        StringUtils.formattedNumber(
                          parseFloat(tempData[tableMeta.rowIndex].balance) -
                            parseFloat(
                              tempData[tableMeta.rowIndex].PayedAmount
                                ? tempData[tableMeta.rowIndex].PayedAmount
                                : 0
                            ) -
                            parseFloat(
                              tempData[tableMeta.rowIndex].gridDiscount
                                ? tempData[tableMeta.rowIndex].gridDiscount
                                : 0
                            ),
                          props.context.store.currencyDecimal
                        );
                      if (e.target.value) {
                        tempData[tableMeta.rowIndex].paidAmountError = "";
                      } else {
                        tempData[tableMeta.rowIndex].paidAmountError =
                          "Paid Amount required";
                      }
                      setTableData(tempData);
                      if (tempData[tableMeta.rowIndex].vBalanceAmount < 0) {
                        tempData[tableMeta.rowIndex].paidAmountError =
                          "Invalid Amount";
                      } else {
                        tempData[tableMeta.rowIndex].paidAmountError = "";
                      }
                    }}
                  ></PText>
                </div>
              ) : mode == "view" ? (
                <div style={{ paddingLeft: 20 }}>
                  {tableData[tableMeta.rowIndex].PayedAmount}
                </div>
              ) : tableMeta.tableData[tableMeta.rowIndex].PayedAmount === 0 ? (
                <div>{tableMeta.tableData[tableMeta.rowIndex].PayedAmount}</div>
              ) : (
                <div style={{ paddingLeft: 20 }}>0.00</div>
              )}
            </div>
          );
        },
      },
    },

    {
      name: "selected",
      label: translate("Discount"),
      options: {
        filter: false,
        sort: false,

        customHeadLabelRender: (value, tableMeta, updateValue) => (
          <div style={{ paddingLeft: 20 }}>{translate("Discount")}</div>
        ),
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div>
              {value &&
              tableData[tableMeta.rowIndex].vOrderType != "Return" &&
              !tableData[tableMeta.rowIndex].isAdvance ? (
                <div style={{ width: "50%", paddingLeft: 20 }}>
                  <PText
                    type="number"
                    disabled={
                      tableData[tableMeta.rowIndex].vOrderType == "Return" ||
                      tableData[tableMeta.rowIndex].isAdvance
                        ? true
                        : false
                    }
                    error={tableData[tableMeta.rowIndex].gridDiscountError}
                    onChange={(e) => {
                      let tempData = [...tableData];
                      tempData[tableMeta.rowIndex].gridDiscount =
                        e.target.value;
                      tempData[tableMeta.rowIndex].vBalanceAmount =
                        StringUtils.formattedNumber(
                          parseFloat(
                            // tempData[tableMeta.rowIndex].actualAmountToPay
                            tempData[tableMeta.rowIndex].balance
                          ) -
                            parseFloat(
                              tempData[tableMeta.rowIndex].PayedAmount
                                ? tempData[tableMeta.rowIndex].PayedAmount
                                : 0
                            ) -
                            parseFloat(
                              tempData[tableMeta.rowIndex].gridDiscount
                                ? tempData[tableMeta.rowIndex].gridDiscount
                                : 0
                            ),
                          props.context.store.currencyDecimal
                        );

                      setTableData(tempData);

                      if (tempData[tableMeta.rowIndex].vBalanceAmount < 0) {
                        tempData[tableMeta.rowIndex].gridDiscountError =
                          "Invalid discount";
                      } else {
                        tempData[tableMeta.rowIndex].gridDiscountError = "";
                      }
                    }}
                  ></PText>
                </div>
              ) : mode == "view" ? (
                <div style={{ paddingLeft: 20 }}>
                  {tableData[tableMeta.rowIndex].discount}
                </div>
              ) : tableMeta.tableData.PaidAmount === 0 ? (
                <div>{tableMeta.tableData[tableMeta.rowIndex].PayedAmount}</div>
              ) : (
                <div style={{ paddingLeft: 20 }}>0.00</div>
              )}
            </div>
          );
        },
      },
    },

    {
      name: "vBalanceAmount",
      label: translate("Balance"),
      options: {
        customHeadLabelRender: (value, tableMeta, updateValue) => (
          <div style={{ paddingRight: 10 }}>{translate("Balance")}</div>
        ),
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ paddingRight: 10 }}>
              {StringUtils.formattedNumber(
                value,
                props.context.store.currencyDecimal
              )}
            </div>
          );
        },
      },
    },
  ];

  const dynamicOptions = {
    filterType: "checkBox",
    serverSide: true,
    tableBodyMaxHeight: "100%",
    tableBodyHeight: 285,
    download: false,
    print: false,
    filter: false,
    pagination: false,
    viewColumns: false,
    selectableRowsHideCheckboxes: true,
    selectableRowsHeader: false,
    rowsSelected: selectedRows,
    onRowSelectionChange: (
      currentRowsSelected,
      allRowsSelected,
      rowsSelected
    ) => {
      handleRowSelectionChange(allRowsSelected, rowsSelected);
    },
    customToolbar: () => {
      return (
        <React.Fragment>
          <Tooltip title={"Pending receipt"}>
            <IconButton
              color="primary"
              onClick={onPrintReportIconButtonClicked}
            >
              <DescriptionIcon />
            </IconButton>
          </Tooltip>
        </React.Fragment>
      );
    },
  };

  function handleRowSelectionChange(data, rowsSelected) {
    setSelectedRows(rowsSelected);
    let selectedTotal = 0;
    let ordersIds = [];

    let tData = [...tableData];
    let ix = 0;
    for (let d of tData) {
      let found = false;
      for (let s of rowsSelected) {
        if (ix == s) {
          found = true;
        }
      }
      if (found) {
        d["selected"] = true;

        d["vBalanceAmount"] = d["vBalanceAmount"]
          ? d["vBalanceAmount"]
          : d.balance;
      } else {
        d["selected"] = false;
        d["PayedAmount"] = StringUtils.formattedNumber(
          0,
          props.context.store.currencyDecimal
        );
        d["vBalanceAmount"] = d.balance;
      }
      ix++;
      ordersIds.push(d.id);
    }
    setTableData(tData);
    if (selectedTotal >= 0) {
      setTotal(
        PricingUtils.formattedNumber(
          selectedTotal,
          props.context.store.currencyDecimal
        )
      );

      if (props.paymentType) {
        if (props.paymentType.id == 1) {
          setToPay(0);
          setBalance(0);
          setPayed(
            PricingUtils.formattedNumber(
              selectedTotal,
              props.context.store.currencyDecimal
            )
          );
          setSelectedItems(ordersIds);
        } else if (props.paymentType.id == 4) {
          setToPay(
            PricingUtils.formattedNumber(
              selectedTotal,
              props.context.store.currencyDecimal
            )
          );
          setDiscount(
            PricingUtils.formattedNumber(
              selectedTotal,
              props.context.store.currencyDecimal
            )
          );
          setBalance(
            PricingUtils.formattedNumber(
              selectedTotal,
              props.context.store.currencyDecimal
            )
          );
          setSelectedItems(ordersIds);
        }
      } else {
        setPaymentTypeError("Payment type required");
        rowsSelected = [];
        setSelectedRows(rowsSelected);
      }
    } else {
      rowsSelected.pop();
      setSelectedRows(rowsSelected);
      props.showMessage(
        "warning",
        translate("Cannot select item: No payments pending...")
      );
    }
  }

  function handleDiscountChange(e) {
    setDiscount(e.target.value);

    let disc = e.target.value ? parseFloat(e.target.value) : 0;

    setToPay(
      StringUtils.formattedNumber(
        parseFloat(total) - disc,
        props.context.store.currencyDecimal
      )
    );
    if (props.paymentType.id == 4) {
      setBalance(
        StringUtils.formattedNumber(
          parseFloat(total) - disc - (payed ? parseFloat(payed) : 0),
          props.context.store.currencyDecimal
        )
      );
    } else {
      setPayed(
        StringUtils.formattedNumber(
          parseFloat(total) - disc,
          props.context.store.currencyDecimal
        )
      );
      setBalance(
        StringUtils.formattedNumber(0, props.context.store.currencyDecimal)
      );
    }
  }

  var biRef = {};

  function showProgress(flag, message) {
    if (message) {
      setProgressMessage(message);
    }
    setShowProgressDialog(flag);
  }

  async function onYesNoClicked(context, value) {
    setConfirmOpen(false);
    if (value == "yes") {
      var payload = createPayload();
      try {
        showProgress(true, "Saving");
        let result = await API.post("/api/v1/accountingtransaction", payload);
        props.showMessage("success", translate("Saved Successfully"));
        SyncUtils.requestSync(result.headers);
        populateDataFromSelectedRow(result.data.id);
        setMode("view");
        props.onRefresh();
        if (getPrint) {
          let paramsList = [
            {
              key: "accountingTransactionId",
              value: result.data.id,
            },
          ];

          biRef.genericReportView.showGenericReportViewer(
            "reports/generic/customer_receipt_voucher",
            paramsList,
            "customer Transaction",
            "v2"
          );
        }
        showProgress(false, "Saving");
      } catch (err) {
        showProgress(false, "Saving");
        if (err.response && err.response.status == 412) {
          console.log(err.response);
        } else {
          props.showMessage(
            "error",
            translate("Not able to save transactions")
          );
        }
      }
    } else {
      console.log("Save cannot be completed...");
    }
  }

  async function onSave(print) {
    setGetPrint(print);
    if (validate()) {
      setConfirmContext({
        title: translate("Are You Sure"),
        message: translate(
          "Are you sure to post the transaction,This action can't revert!"
        ),
        type: "warning",
        open: true,
        yes: true,
        no: true,
      });
      setConfirmOpen(true);
    }
  }

  function getPaymentMeta() {
    let p = [];
    let tData = [...tableData];
    for (let d of tData) {
      let returnFlag = "";
      let type = "";
      if (d.selected) {
        if (d.isAdvance) {
          p.push({
            type: "ADV",
            acctTransId: d.id,
            amount: props.paymentType.id == 4 ? d.PayedAmount : d.balance,
            vOrderType: d.vOrderType,
          });
        } else {
          p.push({
            type: "SALE",
            saleId: d.id,
            amount: props.paymentType.id == 4 ? d.PayedAmount : d.balance,
            discount: props.paymentType.id == 4 ? d.gridDiscount : d.balance,
            vOrderType: d.vOrderType,
          });
        }
      }
      if (props.paymentType.id === 2) {
        if (d.vOrderType == "sale") {
          type = "sale";
          returnFlag = false;
        }
        if (d.vOrderType == "Return") {
          type = "sale";
          returnFlag = true;
        }
        if (d.vOrderType == "Advance") {
          type = "Advance";
          returnFlag = true;
        }
        if (d.vOrderType == "OpeningBalance") {
          type = "OpeningBalance";
          returnFlag = d.paymentMode == "CREDIT" ? true : false;
        }
        p.push({
          type: type,
          date: d.transactionDate,
          id: d.id,
          balanceAmount: d.balance,
          returnFlag: returnFlag,
        });
      }
    }
    return JSON.stringify(p);
  }

  function createPayload() {
    let saveObject = Object.create(null);
    saveObject["customerId"] = customer.cid;
    saveObject["voucherNumber"] = voucherNumber;
    saveObject["fromLedger"] = customerAccount.id;
    saveObject["toLedger"] = account.id;
    saveObject["paymentType"] = props.paymentType.id;
    saveObject["fromLedgerName"] = customerAccount.name;
    saveObject["toLedgerName"] = account.name;
    saveObject["status"] = status;
    saveObject["referenceNumber"] = selectedItems.toString();
    saveObject["paymentMeta"] = getPaymentMeta();
    saveObject["chequeNo"] = checkNo;
    saveObject["chequeDate"] = chequeDate;
    saveObject["chequeStatus"] =
      props.transactionMode == "Bank" ? "PENDING" : "";
    saveObject["description"] = remarks;
    saveObject["transactionDate"] = transactionDate;
    saveObject["transactionDate2"] = transactionDate;
    saveObject["type"] = type;
    saveObject["transactionMode"] = props.transactionMode;
    saveObject["discount"] = discount ? discount : 0;

    saveObject["actualAmount"] =
      props.paymentType.id === 3 ||
      props.paymentType.id === 2 ||
      props.paymentType.id === 4
        ? payed
        : StringUtils.formattedNumber(
            parseFloat(totalPaidAmount) - parseFloat(discount ? discount : 0),
            props.context.store.currencyDecimal
          );

    saveObject["amount"] =
      parseFloat(saveObject["actualAmount"]) +
      parseFloat(discount ? discount : 0);

    saveObject["accountingTransactionItemList"] =
      getAccountingTransactionItemBeanList();
    /*CODEGEN_CREATE_PAYLOAD ######## DO_NOT_REMOVE ###########*/
    if (mode == "create") {
      saveObject["id"] = null;
      saveObject["intVersion"] = 0;
    }
    if (mode == "edit") {
      saveObject["id"] = origObject.id;
      saveObject["intVersion"] = origObject.intVersion;
    }
    return saveObject;
  }

  function getAccountingTransactionItemBeanList() {
    let payLoad = [];
    let tData = [...tableData];
    if (props.paymentType.id == 3) {
      payLoad.push({
        orderId: "",
        invoiceNumber: "",
        date: transactionDate,
        paymentMode: props.transactionMode,
        vorderType: "Advance",
        actualAmountToPay: payed,
        payedAmount: payed,
        gridDiscount: 0,
        vbalanceAmount: payed,
      });
    } else {
      for (let d of tData) {
        if (d.selected) {
          payLoad.push({
            invoiceNumber: d.transactionNo,
            date: d.transactionDate,
            paymentMode: d.paymentMode,
            vorderType: d.vOrderType,
            actualAmountToPay: d.amount,
            payedAmount:
              props.paymentType.id == 1 ? d.vBalanceAmount : d.PayedAmount,
            gridDiscount: d.gridDiscount ? d.gridDiscount : 0,
            vbalanceAmount: props.paymentType.id == 1 ? 0 : d.vBalanceAmount,
            rowId: d.id,
          });
        }
      }
    }
    return payLoad;
  }

  function handlePayedAmountChange(value) {
    setPayed(value);
    if (props.paymentType.id == 2) {
      setBalance(
        parseFloat(total ? total : 0) -
          parseFloat(discount ? discount : 0) -
          parseFloat(value ? value : 0)
      );
    }
  }

  const getcustomFilter = (optionsVendor, rawInput) => {
    if (rawInput.inputValue) {
      let newOptions = [];
      const input = rawInput.inputValue.toUpperCase();
      optionsVendor.forEach((element) => {
        if (element.name.toUpperCase().startsWith(input)) {
          newOptions.push(element);
        }
      });
      return newOptions.sort((a, b) => a.name.length - b.name.length);
    } else {
      return optionsVendor;
    }
  };

  function onNewClicked() {
    showAccountingCrud();
    props.setShowCrud(true);
    setCustomer("");
    setMode("create");
    setAccount("");
    setDiscount("");
    setTableData([]);
    setnewButtonClicked(true);
    setVouchernumber("AUTO");
    if (props.transactionMode === "Bank") {
      setChequeDate(null);
      setCheckNo("");
    }
  }

  const content = (
    <div>
      <Grid container>
        <Grid item xs={3}>
          <table>
            <tbody>
              <tr>
                <td style={{ width: "45%" }}>
                  <Typography variant="body1">
                    {translate("Voucher Number")}
                  </Typography>
                </td>
                <td style={{ width: "70%" }}>
                  <PText
                    value={voucherNumber}
                    error={voucherNumberError}
                    onChange={(e) => setVouchernumber(e.target.value)}
                    InputProps={{ readOnly: true }}
                  ></PText>
                </td>
              </tr>
              <tr>
                <td style={{ width: "40%" }}>
                  <Typography variant="body1">{translate("Date")}</Typography>
                </td>
                <td style={{ width: "70%" }}>
                  <PDatePicker
                    value={transactionDate}
                    type="date"
                    error={transactionDateError}
                    onChange={(e) => {
                      let d = new Date();
                      e.$d.setHours(d.getHours());
                      e.$d.setMinutes(d.getMinutes());
                      e.$d.setSeconds(d.getSeconds());
                      setTransactiondate(e.$d.toISOString());
                    }}
                    // onChange={(e) => setTransactiondate(e.$d.toISOString())}
                  ></PDatePicker>
                </td>
              </tr>
              {/*CODEGEN_REACT_COMPONENT ######## DO_NOT_REMOVE ###########*/}
            </tbody>
          </table>
        </Grid>
        <Grid item xs={6}>
          <table width="100%">
            <tbody>
              <tr>
                <td style={{ width: "20%" }}>
                  <Typography variant="body1">
                    {translate("Customer")}
                  </Typography>
                </td>
                <td style={{ width: "80%" }}>
                  <PSelect
                    options={optionsCustomer}
                    filterOptions={getcustomFilter}
                    value={customer}
                    placeholder={translate("Select...")}
                    errorMessage={customerError}
                    disabled={mode === "view" ? true : false}
                    onChange={(event, newValue) => {
                      setCustomer(newValue);
                      getCustomerAccount(newValue.id);
                    }}
                  ></PSelect>
                </td>
              </tr>
              <tr>
                <td style={{ width: "20%" }}>
                  <Typography variant="body1">
                    {translate("Account")}
                  </Typography>
                </td>
                <td style={{ width: "80%" }}>
                  <PSelect
                    type="number"
                    options={optionsLedger}
                    value={account}
                    disabled={mode === "view" ? true : false}
                    placeholder={translate("Select...")}
                    errorMessage={accountError}
                    onChange={(event, newValue) => {
                      setAccount(newValue);
                    }}
                  ></PSelect>
                </td>
              </tr>
            </tbody>
          </table>
        </Grid>
        <Grid item xs={3}>
          <table width="100%">
            <tbody>
              <tr>
                <td style={{ width: "30%" }}>
                  <Typography variant="body1">{translate("Type")}</Typography>
                </td>
                <td>
                  <PText
                    value={props.paymentType.name}
                    InputProps={{ readOnly: true }}
                  ></PText>
                </td>
              </tr>
              {props.transactionMode === "Cash"
                ? false
                : true && (
                    <tr>
                      <td style={{ width: "30%" }}>
                        <Typography variant="body1">
                          {translate("Cheque No")}
                        </Typography>
                      </td>
                      <td style={{ width: "70%" }}>
                        <PText
                          disabled={transactionMode === "Cash" ? true : false}
                          error={chequeNoError}
                          value={checkNo}
                          onChange={(e) => setCheckNo(e.target.value)}
                        ></PText>
                      </td>
                    </tr>
                  )}
              {props.transactionMode === "Cash"
                ? false
                : true && (
                    <tr>
                      <td style={{ width: "40%" }}>
                        <Typography variant="body1">
                          {translate("Cheque date")}
                        </Typography>
                      </td>
                      <td style={{ width: "70%" }}>
                        <PDatePicker
                          value={chequeDate}
                          type="date"
                          error={chequeDateError}
                          onChange={(e) => {
                            let d = new Date();
                            e.$d.setHours(d.getHours());
                            e.$d.setMinutes(d.getMinutes());
                            e.$d.setSeconds(d.getSeconds());
                            setChequeDate(e.$d.toISOString());
                          }}
                        ></PDatePicker>
                      </td>
                    </tr>
                  )}
            </tbody>
          </table>
        </Grid>
        <Grid xs={12}>
          <MUIDataTable
            title={
              <Typography variant="h6" style={{ fontWeight: "bold" }}>
                {translate("Total to receive")}: {amount}
              </Typography>
            }
            columns={props.paymentType.id === 4 ? editableColumns : columns}
            options={
              props.paymentType.id === 3 || props.paymentType.id === 2
                ? dynamicOptions
                : options
            }
            data={tableData}
          ></MUIDataTable>
        </Grid>
        {mode == "view"
          ? false
          : true && (
              <Grid xs={12} style={{ paddingTop: 5 }}>
                <table width="100%" style={{ paddingRight: 5 }}>
                  <tbody>
                    <tr>
                      {total < 0 ? (
                        <td style={{ width: "123px", paddingLeft: 10 }}>
                          <Typography variant="body1">
                            {translate("To pay")}
                          </Typography>
                        </td>
                      ) : (
                        <td style={{ width: "123px", paddingLeft: 10 }}>
                          <Typography variant="body1">
                            {translate("To receive")}
                          </Typography>
                        </td>
                      )}
                      <td style={{ width: "7%" }}>
                        <PText
                          placeholder="0.00"
                          value={total < 0 ? total * -1 : total * 1}
                          InputProps={{ readOnly: true }}
                        ></PText>
                      </td>
                      <td style={{ paddingLeft: 15, width: "8%" }}>
                        <Typography variant="body1">
                          {translate("Discount")}
                        </Typography>
                      </td>
                      <td style={{ width: "7%" }}>
                        <PText
                          placeholder="0.00"
                          value={discount}
                          error={discountError}
                          onChange={(e) => handleDiscountChange(e)}
                          InputProps={{
                            readOnly:
                              props.paymentType.id == 3 ||
                              total < 0 ||
                              props.paymentType.id == 4 ||
                              props.paymentType.id == 2,
                          }}
                        ></PText>
                      </td>
                      <td style={{ paddingLeft: 15, width: "7%" }}>
                        <Typography variant="body1">
                          {translate("After %")}
                        </Typography>
                      </td>
                      <td style={{ width: "7%" }}>
                        <PText
                          value={toPay}
                          // value={total < 0 ? toPay * -1 : toPay * 1}
                          placeholder="0.00"
                          InputProps={{ readOnly: true }}
                        ></PText>
                      </td>
                      <td style={{ paddingLeft: 15, width: "7%" }}>
                        {total < 0 ? (
                          <Typography variant="body1">
                            {translate(" Paid")}
                          </Typography>
                        ) : (
                          <Typography variant="body1">
                            {translate("Receive")}
                          </Typography>
                        )}
                      </td>
                      <td style={{ width: "7%" }}>
                        <PText
                          placeholder="0.00"
                          // value={total < 0 ? payed * -1 : payed * 1}
                          value={payed}
                          error={payedError}
                          onChange={(e) =>
                            handlePayedAmountChange(e.target.value)
                          }
                          InputProps={{
                            readOnly:
                              props.paymentType.id == 4 ||
                              props.paymentType.id == 1 ||
                              props.paymentType.id == 2
                                ? groupedReturnAmount == groupedSaleAmount ||
                                  groupedReturnAmount > groupedSaleAmount
                                : false,
                          }}
                        ></PText>
                      </td>

                      <td style={{ paddingLeft: 15, width: "7%" }}>
                        <Typography variant="body1">
                          {translate("Balance")}
                        </Typography>
                      </td>
                      <td style={{ width: "7%" }}>
                        <PText
                          placeholder="0.00"
                          value={balance}
                          // value={
                          //   balance < 0 || total < 0 ? balance * -1 : balance * 1
                          // }
                          onChange={(e) => setBalance(e.target.value)}
                          InputProps={{ readOnly: true }}
                        ></PText>
                      </td>
                      <td style={{ paddingLeft: 15 }}>
                        <Typography variant="body1">
                          {translate("Remarks")}
                        </Typography>
                      </td>
                      <td style={{ paddingRight: 5 }}>
                        <PText
                          value={remarks}
                          onChange={(e) => setRemarks(e.target.value)}
                        ></PText>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Grid>
            )}
      </Grid>
    </div>
  );
  return (
    <div>
      <PDialog
        content={content}
        showCrud={true}
        title={windowTitle}
        maxWidth={"lg"}
        fullWidth={true}
        open={true}
        onSave={() => onSave(false)}
        onPrint={() => onSave(true)}
        onCloseWindow={onCloseWindow}
        mode={mode}
        showPrint={mode === "view" ? false : true}
        onNewClicked={onNewClicked}
        showNew={mode == "create" ? false : true}
      ></PDialog>
      {confirmOpen && (
        <PConfirm
          open={confirmOpen}
          context={confirmContext}
          onButtonClicked={onYesNoClicked}
        ></PConfirm>
      )}
      <GenericReportViewer
        biRef={biRef}
        showMessage={props.showMessage}
      ></GenericReportViewer>
      <PFileViewer
        openWindow={openFileViewWindow}
        setOpenWindow={setOpenFileViewWindow}
        showMessage={props.showMessage}
        filesList={previewFileList}
        setAlert={props.setAlert}
        disableDefaultPrint={true}
      ></PFileViewer>

      {showProgressDialog && (
        <PDialog
          content={
            <Grid container style={{ width: 200, margin: 20 }}>
              <Grid item xs={12}>
                <CircularProgress disableShrink /> {progressMessage}
              </Grid>
            </Grid>
          }
          open={true}
          borderLess={true}
        ></PDialog>
      )}
    </div>
  );
}
